import React from 'react';
import { MODAL_PORTAL_ID } from '../types';

const ModalControlsPortal: React.VFC = () => <div id={MODAL_PORTAL_ID} />;

ModalControlsPortal.displayName = 'ModalControlsPortal';
export default ModalControlsPortal;
